export const PREFIX_ID = 'id_';

export const TRANSLATIONS = [
  {
      text: 'English',
      value: 'en',
  },
  {
      text: 'Russian',
      value: 'ru',
  },
  {
      text: 'Norwegian',
      value: 'no',
  },
  {
      text: 'German',
      value: 'de',
  },
  {
      text: 'French',
      value: 'fr',
  },
  {
      text: 'Japanese',
      value: 'ja',
  },
  {
      text: 'Spanish',
      value: 'es',
  },
  {
      text: 'Swedish',
      value: 'sv',
  },
  {
      text: 'Turkish',
      value: 'tr',
  },
];

export const ROLES = [
    {
        label: 'ROLE_MEDIA_BUYER',
        value: 'ROLE_MEDIA_BUYER'
    },
    {
        label: 'ROLE_STATISTICS_FINANCE',
        value: 'ROLE_STATISTICS_FINANCE'
    },
    {
        label: 'ROLE_ALL_RADIUS_CAMPAIGN',
        value: 'ROLE_ALL_RADIUS_CAMPAIGN'
    },
    {
        label: 'ROLE_ALL_SUBSCRIPTION_CAMPAIGN',
        value: 'ROLE_ALL_SUBSCRIPTION_CAMPAIGN'
    }
]